import * as yup from "yup";

export const GotraValidation = yup.object().shape({
    name: yup.string().required("Required"),
    status: yup.string().required("Required"),
});